import Link from "next/link";
import './bite-brand.css';

export function BiteMaker() {
  return (
    <div className="bite-maker">
      <a href="https://bullstory.io" className="bite-maker__brand" aria-label="불스토리 홈페이지">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src="/logo-bull.png" alt="" width={40} height={40} />
        <span>불스토리</span>
      </a>
      <p>불스토리가 만든 주식 분석 서비스, 바이트</p>
    </div>
  );
}

export function BiteBrand({ mode, href='/' }: { mode?: string; href?:string }) {
  return (
    <Link href={href} className="bd-brand" aria-label="Bite 홈">
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src="/bite-logo.png" alt="" />
      <span className="bd-brand-name">Bite<small>by Bullstory</small></span>
      {mode ? <span className="bd-brand-mode">{mode}</span> : null}
    </Link>
  );
}
